import { api, TmrBaseResource, responseErrorCheck, ResourcePage, IdentifierReel, IdentifierEvent } from 'stylewhere/api'

export class IdentifierEvents extends TmrBaseResource {
  static endpoint = `/api/v1/identifierEvents` ///tracking
  static endpointItemIdenfier = `/api/v1/identifierEvents/itemIdentifier` ///tracking

  static async getIdentifierEvents(
    id: string,
    page = 0,
    size = 25,
    sort = 'creationDate,desc'
  ): Promise<ResourcePage<IdentifierEvent>> {
    return api
      .get<ResourcePage<IdentifierEvent>>(`${this.endpointItemIdenfier}/${id}`, {
        page,
        size,
        sort
      })
      .then(responseErrorCheck)
  }
}
